import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import CookieConsent from 'react-cookie-consent';

import config from '../../../../config';
import { version } from '../../../../../package.json';

import { getLanguagePath } from '../../../Intl/IntlActions';

import FontCustom from '../../../../components/Content/FontCustom';
import AppLogo from '../AppLogo';
import AppAdvantages from '../AppAdvantages';
import CmsPanel from '../../../Cms/components/content/CmsPanel';

import UserAdminLoginSwitcher from '../../../User/components/admin/UserAdminLoginSwitcher';


export function Footer(props) {
    return (
        <footer className="footer py-4 bg-tertiary border-warning text-primary">
            <Container fluid="xl" className="my-auto">
                <Row>
                    <Col xs="12" md="4" lg="4">
                        <div className="pl-2 pl-md-0">
                            <div className="text-left">
                                <AppLogo suffix="bw" style={{ maxWidth: '61%', maxHeight: '45px', filter: 'brightness(0.7) grayscale(100%)', 'WebkitFilter': 'grayscale(100%)' }} />
                                <span className="d-block text-xs baseline"><FormattedMessage id="appSeoBaseline" defaultMessage={config.application.seo.defaultBaseline} /></span>
                            </div>

                            <Row className="mt-5">
                                <Col xs="12" md="6" className="" style={{ marginLeft: '-1em' }}>
                                    <div className="d-flex justify-content-between mb-2 py-2 text-left">
                                        <a href="https://facebook.com/atremoplus/" className="d-inline-block w-50 pr-2 text-primary" target="_blank" rel="noopener noreferrer">
                                            <FontCustom name="facebook" size="2x" className="d-block" />
                                        </a>
                                        <a href="https://www.linkedin.com/company/atremoplus/" className="d-inline-block w-50 pr-2 text-primary" target="_blank" rel="noopener noreferrer">
                                            <FontCustom name="linkedin" size="2x" className="d-block" />
                                        </a>
                                        <a href="https://www.instagram.com/atremoplus/" className="d-inline-block w-50 pr-2 text-primary" target="_blank" rel="noopener noreferrer">
                                            <FontCustom name="instagram" size="2x" className="d-block" />
                                        </a>
                                        <a href="https://www.youtube.com/channel/UCbDcyG3nQPZSyY9QZrNF07Q" className="d-inline-block w-50 pr-2 text-primary" target="_blank" rel="noopener noreferrer">
                                            <FontCustom name="youtube" size="2x" className="d-block" />
                                        </a>
                                    </div>
                                </Col>
                                <Col>
                                    <a href={`tel:${config.application.phone}`} className="d-block h6 text-primary">{config.application.phone}</a>
                                    <Link to={getLanguagePath('/contact', props.intl.locale)} className="d-block h6 text-primary"><FontCustom name="email" size={2} /> <FormattedMessage id="contactByEmail" defaultMessage="By email" /></Link>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col>
                        <div className="mt-5 mt-md-0">
                            <AppAdvantages />
                        </div>

                        <div className="pl-2 pl-md-0">
                            <CmsPanel slug="footer-links" isTemplate />
                        </div>
                    </Col>
                </Row>

                <hr />

                <div className="copyright text-center my-auto">
                    &copy;{new Date().getFullYear()} &middot; {config.application.name} &middot; <small>v.{version}</small>
                </div>
                <div className="copyright text-center mt-1" style={{ fontSize: '0.6rem' }}>
                    <small>
                        Made with <FontAwesome name="coffee" /> by <a href="https://offaxis.io" className="text-gray-600" target="_blank" rel="noopener noreferrer">OFF<span style={{ color: '#D90000' }}>/</span>AXIS</a>
                    </small>
                </div>

                <hr />
                <UserAdminLoginSwitcher />
                {process.env.NODE_ENV === 'development' && (
                    <div className="display-4 my-2 text-center text-danger">
                        <span className="d-block d-sm-none">XS</span>
                        <span className="d-none d-sm-block d-md-none">SM</span>
                        <span className="d-none d-md-block d-lg-none">MD</span>
                        <span className="d-none d-lg-block d-xl-none">LG</span>
                        <span className="d-none d-xl-block">XL</span>
                    </div>
                )}
            </Container>
            <CookieConsent
                buttonText="OK"
                buttonClasses="btn btn-outline-primary btn-sm"
                buttonStyle={{}}
            >
                <FormattedMessage id="appCookieConsentText" defaultMessage="By continuing your visit to this site, you accept the use of cookies for the purposes of the functioning of the proposed service and statistics. No personal data will be communicated without your prior consent." />
                {' '}
                <Button size="sm" color="warning" outline tag={Link} to={getLanguagePath('/privacy-policy', props.intl.locale)} target="_blank"><FormattedMessage id="appCookieConsentPrivacyLink" defaultMessage="See our privacy policy" /></Button>
            </CookieConsent>
        </footer>
    );
}


Footer.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Footer);
